import { IVisaPrepForm } from '../../../../../../types';

type Fields = Pick<IVisaPrepForm, 'borderRefusals'>;

type Params = Fields;

export function getPageStatus({ borderRefusals }: Params): { complete: boolean } {
  let complete = false;
  if (!borderRefusals || borderRefusals.length === 0) {
    complete = false;
  } else {
    complete = !borderRefusals.some(refusal => {
      return refusal.airport === '' || refusal.reason === '' || refusal.reference === '' || refusal.refusalDate === '';
    });
  }

  return { complete };
}
